import Vue from 'vue'

const auditInstance = Vue.extend(require('./audit.vue').default);
let instance = null
let confirmPromise = null
let confirmResolve = null

let getInstance = () => {
  return new auditInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (confirmResolve) {
    confirmResolve(false)
    confirmResolve = null
  }
  confirmPromise = null
}

let audit = (i,t) => {
  if (instance) {
    close()
  }
  instance = getInstance()
  document.body.appendChild(instance.$el);
  instance.open(i,t)

  return confirmPromise
}

export default audit
